import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Slide from '../Slide';
import styles from './styles.module.scss';
import { LocaleContext } from '../../Banner';
import { SlidePropTypes } from '../Slide/Slide';

const SlideWrapper = ({ slider, num, isMobile }) => {
  const { url } = slider;
  const { dataJurisdiction } = useContext(LocaleContext);

  return (
    <section
      data-jurisdiction={dataJurisdiction}
      className={cn(styles.slideData)}
      data-testid={`url-${num}`}
      data-test-url={url || 'reg-open'}
    >
      <div className={cn(styles.slides)} data-testid={`slides-${num}`}>
        <Slide slider={slider} isMobile={isMobile} />
      </div>
    </section>
  );
};

SlideWrapper.propTypes = {
  ...SlidePropTypes,
  num: PropTypes.number.isRequired,
};

export default memo(SlideWrapper);
